module.exports = __webpack_public_path__ + "static/media/index.8c28eaf3.scss";


//////////////////
// WEBPACK FOOTER
// ./src/index.scss
// module id = 241
// module chunks = 0